import ImPropTypes from 'react-immutable-proptypes';
import cn from 'classnames';

import example from './Example.module.scss';

const EnumModel = ({ value, getComponent, schemaType }) => {
  let ModelCollapse = getComponent('ModelCollapse');
  let collapsedContent = <span>Array [ {value.count()} ]</span>;
  return (
    <div className={cn('prop-enum')}>
      {/* <div
        className={cn(example.example__hardcode, {
          [example.example__hardcode__mini]: schemaType === 'mini',
        })}
      >
        Enum:
      </div> */}
      <ModelCollapse
        expanded={true}
        modelType="enum"
      >
        <div
          className={cn(example.example__text, {
            [example.example__text__mini]: schemaType === 'mini',
          })}
          collapsedContent={collapsedContent}
        >
          [ {value.join(', ')} ]
        </div>
      </ModelCollapse>
    </div>
  );
};
EnumModel.propTypes = {
  value: ImPropTypes.iterable,
  getComponent: ImPropTypes.func,
};

export default EnumModel;
